export { COLORS, type Color } from "./colors";
export { getColorByString } from "./get-color-by-string";
